var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.88675 6L10.0001 8.10667V8C10.0001 7.46957 9.78937 6.96086 9.4143 6.58579C9.03922 6.21071 8.53051 6 8.00008 6H7.88675ZM5.02008 6.53333L6.05341 7.56667C6.02008 7.70667 6.00008 7.84667 6.00008 8C6.00008 8.53043 6.21079 9.03914 6.58587 9.41421C6.96094 9.78929 7.46965 10 8.00008 10C8.14675 10 8.29341 9.98 8.43341 9.94667L9.46675 10.98C9.02008 11.2 8.52675 11.3333 8.00008 11.3333C7.11603 11.3333 6.26818 10.9821 5.64306 10.357C5.01794 9.7319 4.66675 8.88406 4.66675 8C4.66675 7.47333 4.80008 6.98 5.02008 6.53333ZM1.33341 2.84667L2.85342 4.36667L3.15341 4.66667C2.05341 5.53333 1.18675 6.66667 0.666748 8C1.82008 10.9267 4.66675 13 8.00008 13C9.03341 13 10.0201 12.8 10.9201 12.44L11.2067 12.72L13.1534 14.6667L14.0001 13.82L2.18008 2M8.00008 4.66667C8.88414 4.66667 9.73198 5.01786 10.3571 5.64298C10.9822 6.2681 11.3334 7.11595 11.3334 8C11.3334 8.42667 11.2467 8.84 11.0934 9.21333L13.0467 11.1667C14.0467 10.3333 14.8467 9.24 15.3334 8C14.1801 5.07333 11.3334 3 8.00008 3C7.06675 3 6.17341 3.16667 5.33342 3.46667L6.78008 4.9C7.16008 4.75333 7.56675 4.66667 8.00008 4.66667Z",
    fill: "#222723"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.be5a6936068da12fa62615f3c0ee46c2.svg";
export { ForwardRef as ReactComponent };